export const classicSelectFields = [
  'type__name',
  'structural-design__code',
  'structural-design__fefco-code',
  'structural-design__ecma-code'
]
